import {
  Button,
  ButtonGroup,
  Content,
  Dialog,
  Divider,
  Heading,
  useDialogContainer,
  TextField,
  Flex,
  Text,
} from "@adobe/react-spectrum";
import React, { useState } from "react";
import { useOktaAuth } from "@okta/okta-react";
import PropTypes from "prop-types";
import {
  error as ErrorToast,
  success as SuccessToast,
} from "@react/react-spectrum/Toast";
import { gtmhApi } from "../../../../api/gtmhApi";
import useUserProfile from "../../../../context/user-context";

export default function DeleteAccountDialog({
  rowInfo,
  // status,
  refreshTable,
  isPageLoading,
  setPageLoading,
}) {
  const { user } = useUserProfile();
  const { authState } = useOktaAuth();

  const [deleteSubRequest, setDeleteSubRequest] = useState({
    sub_id: rowInfo?.sub_id,
    comment: "",
    user_id: user?.userId,
    user_name: user?.name,
    status: rowInfo?.status,
  });

  const [deleteParentRequest, setDeleteParentRequest] = useState({
    parent_id: rowInfo?.parent_id,
    comment: "",
    user_id: user?.userId,
    user_name: user?.name,
    status: rowInfo?.status,
  });

  const [errorMessage, setErrorMessage] = useState("");

  const dialog = useDialogContainer();

  const handleSubDelete = () => {
    setPageLoading(true);
    gtmhApi
      .deleteSub(deleteSubRequest, authState.accessToken)
      .then((data) => {
        if (
          data?.results?.gtm_sub?.wf_id ||
          data?.results?.gtm_sub?.status === "deleted"
        ) {
          dialog.dismiss();
          refreshTable();
          setPageLoading(false);
          const successMessage = data?.results?.gtm_sub?.wf_id
            ? `Successfully triggered deletion of ${rowInfo.sub_name} (${rowInfo.sub_id})! WfId: ${data?.results?.gtm_sub?.wf_id}`
            : `Successfully deleted ${rowInfo.sub_name} (${rowInfo.sub_id})!`;
          SuccessToast(successMessage, {
            timeout: 5000,
          });
        } else {
          setPageLoading(false);
          setErrorMessage(data.results?.error_payload.message);
        }
      })
      .catch((error) => {
        console.log("error");
        dialog.dismiss();
        setPageLoading(false);
        ErrorToast(error.response?.data?.message || "Error deleting company", {
          timeout: 5000,
        });
      });
  };

  // const handleParentDelete = () => {
  //   setPageLoading(true);
  //   gtmhApi
  //     .deleteParent(deleteParentRequest, authState.accessToken)
  //     .then((data) => {
  //       if (data?.results?.gtm_sub?.wf_id) {
  //         dialog.dismiss();
  //         refreshTable();
  //         setPageLoading(false);
  //         SuccessToast(
  //           `Successfully triggered deletion of ${rowInfo.sub_name} (${rowInfo.parent_id})! WfId: ${data?.results?.gtm_sub?.wf_id}`,
  //           {
  //             timeout: 5000,
  //           }
  //         );
  //       } else {
  //         setPageLoading(false);
  //         setErrorMessage(data.results?.error_payload.message);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("error");
  //       dialog.dismiss();
  //       setPageLoading(false);
  //       ErrorToast(error.response?.data?.message || "Error deleting company", {
  //         timeout: 5000,
  //       });
  //     });
  // };

  const handleCancel = () => {
    dialog.dismiss();
  };

  return (
    <Dialog>
      <Heading>{`Delete ${rowInfo.parent ? "Parent" : "Sub"}: ${
        rowInfo.sub_name
      } (${rowInfo.sub_id})`}</Heading>
      <Divider />
      <Content>
        {errorMessage !== "" && (
          <Text UNSAFE_style={{ color: "red" }}>{errorMessage}</Text>
        )}
        <Flex marginBottom="15px">
          {rowInfo?.status === "active"
            ? `Deletion will move the company to the pending-deletion status and a workflow will be triggered. 
            Within the next 7 days the account will either be deleted or reverted back to the current status (active) based on its coverage.
            Proceed to delete?`
            : `Deletion will occur instantaneously as this sub is in the in-review state. Proceed to delete?`}
        </Flex>
        <TextField
          label="Comment"
          width="100%"
          onChange={(val) => {
            setDeleteParentRequest({ ...deleteParentRequest, comment: val });
            setDeleteSubRequest({ ...deleteSubRequest, comment: val });
          }}
          marginTop="10px"
        />
      </Content>
      <ButtonGroup>
        <Button onPress={handleCancel} variant="secondary">
          Cancel
        </Button>
        <Button
          // onPress={(val) =>
          //   rowInfo.parent ? handleParentDelete(val) : handleSubDelete(val)
          // }
          onPress={handleSubDelete}
          color="primary"
          variant="accent"
          isDisabled={isPageLoading}
        >
          Delete
        </Button>
      </ButtonGroup>
    </Dialog>
  );
}

DeleteAccountDialog.propTypes = {
  rowInfo: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array,
      PropTypes.object,
      PropTypes.arrayOf(PropTypes.object),
    ])
  ).isRequired,
  // status: PropTypes.string.isRequired,
  refreshTable: PropTypes.func.isRequired,
  setPageLoading: PropTypes.func.isRequired,
  isPageLoading: PropTypes.bool.isRequired,
};
